import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import { Form, Row, Col, Image, Button, Table } from "react-bootstrap";
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
  Radio,
  TextField,
} from "@material-ui/core";

import Alert from "react-s-alert";
import Switch from "react-switch";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputNumberFuncWithE } from "../../../../../function/InputCharNumCheckFunc";
import SimpleReactLightbox from "simple-react-lightbox";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { NewSelectBoxInput } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import axios from "axios";
import isEmpty from "../../../../../store/validation/is-Empty";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  super_admin_get_country,
  super_admin_get_state,
  super_admin_get_city,
  super_admin_get_restaurant_list,
} from "../../../../../store/actions/SuperAdminActions/superAdminOnlineAndOfflineAction";
import { vendor_create_new_offer } from "../../../../../store/actions/vendorOffersAndEventsAction";
import {
  serverApi,
  videoUploadSize,
  imageUploadSize,
} from "../../../../../config/Keys";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import { ReusableOnboardingMapButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import ListMarchantTableHead from "../TableHeadBody/ListMarchantTableHead";
import ListMerchantTableBody from "../TableHeadBody/ListMerchantTableBody";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

//slider settings
const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

/****************************
 * @DESC Amealio Offers Type
 ***************************/
const amealioOffers = [
  {
    id: 0,
    value: 1,
    title: "Amealio Offers",
    paragraph: "Amealio is accountable for offer amount",
    show: true,
  },
  {
    id: 1,
    value: 2,
    title: "Offer splits between Merchant & Admin",
    paragraph:
      "Based on the ratio/price amount will be split between merchant and admin",
    show: false,
  },
];

const percentArr = [
  {
    id: 0,
    value: true,
    title: "Percentage",
  },
  {
    id: 1,
    value: false,
    title: "Fixed Amount",
  },
];

const AdminAddOnlineOffers = (props) => {
  /************ Routing ***********/
  let history = useHistory();
  const location = useLocation();
  /************ Dispatch and Selector ***********/
  const dispatch = useDispatch();
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });
  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth?.user?.accessToken : "";
  });

  // const validate = (values) => {
  //   const errors = {};
  //   if (values.isPercentage) {
  //     errors.maximum_discount_applied =
  //       "Maximum discount applied value is required";
  //   }
  //   return errors;
  // };

  const [loading, setLoading] = useState();
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const [days, setDays] = useState([
    { name: "All" },
    { name: "Takeaway" },
    { name: "Dine-In" },
    { name: "Curbside" },
    { name: "Skip the line" },
    { name: "Catering" },
    { name: "Delivery" },
  ]);

  const onClickChangePrimary = () => {
    formik1.setFieldValue("mark_as_primary", !formik1.values?.mark_as_primary);
    formik1.setFieldValue("active", true);
  };

  /**************************
   * @DESC County State City
   **************************/
  const onChangeCountry = (e) => {
    let blankArr = [];
    formik1.setFieldValue("headCheck", false);
    formik1.setFieldValue("restaurants", blankArr);
    formik1.setFieldValue("country", e.target.value);
    formik1.setFieldValue("state", "");
    formik1.setFieldValue("city", "");
    setState({
      ...state,
      restaurantType: "",
    });
    setRestaurantTypeFilter("");
    setRestaurantCityFilter("");
    dispatch(super_admin_get_state(token, e.target.value));
  };

  const onChangeState = (e) => {
    formik1.setFieldValue("state", e.target.value);
    formik1.setFieldValue("city", "");
    setState({
      ...state,
      restaurantType: "",
    });
    setRestaurantTypeFilter("");
    setRestaurantCityFilter("");
    dispatch(
      super_admin_get_city(token, formik1.values?.country, e.target.value)
    );
  };

  const onChangeCity = (e) => {
    formik1.setFieldValue("city", e.target.value);
    setState({
      ...state,
      restaurantType: "",
    });
    setRestaurantTypeFilter("");
    setRestaurantCityFilter("");
    dispatch(
      super_admin_get_restaurant_list(
        token,
        formik1.values?.country,
        formik1.values?.state,
        e.target.value
      )
    );
  };

  const [countries, setAllCountries] = useState([]);
  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);
  const [disable, setDisable] = useState(false);

  const [state, setState] = useState({
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    progress: 0,
    actionButton: false,
    isPercentage: true,
    restaurantType: "",
    restaurantCity: "",
    errors: {},
  });

  const [restaurantTypeFilter, setRestaurantTypeFilter] = useState("");
  const [restaurantCityFilter, setRestaurantCityFilter] = useState("");

  const thumbnail = true;

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik1.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik1.setFieldValue("photos", mergedData);
    if (thumbnail) {
      let thumbData = formik1.values.photo_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formik1.setFieldValue("photo_thumbnails", thumbData);
    }

    cancelFiles(file);
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    if (formik1.values.photos.length + e.target.files.length > 5) {
      Alert.error(`<h4>Cannot upload more than 5 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name = "ADMIN";
      // if (props.onboarding.restaurant_name) {
      //   restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      // } else {
      //   restaurant_name = "";
      // }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik1.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik1.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik1.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Uploaded Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik1.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik1.values.photo_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik1.setFieldValue("photos", allImages);
    formik1.setFieldValue("photo_thumbnails", thumbImage);
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    if (e.target.files) {
      // e.preventDefault();
      const vendor_id = props.auth.user.VendorUser._id;
      const restaurant_name = "ADMIN";
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      for (let i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i].size > videoUploadSize) {
          alert("File is too Big");
          return (flag = false);
        } else {
          if (state.restaurant_video && state.restaurant_video.length > 0) {
            if (state.restaurant_video[0].name === e.target.files[i].name) {
              return (flag = true);
            }
          }
          if (!flag) {
            data.append("file", e.target.files[i]);
          }
        }
      }

      var newData = e.target.files;
      if (!flag) {
        const setProgress = (percent) => {
          setState({ ...state, progress: percent });
        };
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            onUploadProgress: (progressEvent) => {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            },
             timeout: 60*1000  //seconds
          })
          
          .then((res) => {
            setState({
              ...state,
              restaurant_video: newData,
              video_url: res.data,
              actionButton: true,
            });
            Alert.success(`<h4>Video Uploaded Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
            setDisable(true);
          })
          .catch((err) => {
            Alert.error(`<h4>${err}</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      } else {
        Alert.error(`<h4>Can not upload the same video</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
    setDisable(false);
  };

  const [showSearch, setShowSearch] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [searchData, setSearchData] = useState("");

  const onClickDisplaySearch = (e) => {
    e.preventDefault();
    setShowSearch(!showSearch);
    setShowFilter(false);
  };
  const onClickDisplayFilter = (e) => {
    e.preventDefault();
    setShowFilter(!showFilter);
    setShowSearch(false);
  };

  const offerTypeAction = (value) => {
    formik1.setFieldValue("offerType", value);
  };

  const isPercentageAction = (value) => {
    formik2.setFieldValue("isPercentage", value);
    formik2.setFieldValue("discount", "");
  };

  const onChangeDaysEatOut = (icon) => {
    let restaurantTypeArray = formik2.values?.service_type;
    let blankArr = [];
    if (icon.name === "All" || restaurantTypeArray.length >= 5) {
      restaurantTypeArray = blankArr;
      formik2.setFieldValue("service_type", blankArr);
      restaurantTypeArray.push("All");
      formik2.setFieldValue("service_type", restaurantTypeArray);
    } else {
      if (restaurantTypeArray.length === 0) {
        restaurantTypeArray.push(icon.name);
      } else if (restaurantTypeArray.some((icons) => icons === "All")) {
        restaurantTypeArray = blankArr;
        formik2.setFieldValue("service_type", blankArr);
        restaurantTypeArray.push(icon.name);
        formik2.setFieldValue("service_type", restaurantTypeArray);
      } else {
        let isAlreadyPresent = restaurantTypeArray.some(
          (icons) => icons === icon.name
        );
        if (isAlreadyPresent) {
          let indexOf = restaurantTypeArray.indexOf(icon.name);
          if (indexOf === 0 || indexOf) {
            restaurantTypeArray.splice(indexOf, 1);
          }
        } else {
          restaurantTypeArray.push(icon.name);
        }
      }
      formik2.setFieldValue("service_type", restaurantTypeArray);
    }
  };

  const formik1 = useFormik({
    initialValues: {
      headCheck: false,
      name: "",
      description: "",
      mark_as_primary: false,
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      coupon_code: "",
      maximum_usage_limit: 0,
      active: false,
      useLimit: "",
      useFrequency: "",
      maxUsage: 0,
      offerType: 1,
      country: "",
      state: "",
      city: "",
      restaurants: [],
      photos: [],
      photo_thumbnails: [],
      videos: [],
      terms_and_condition: "",
      refund_and_cancellation: "",
      isOnline: true,
      isGlobal: true,
      pointOfEntry: "ADMIN",
      settlementType: "ADMIN",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .required("Offer Name is required")
        .min(1, "Minimum 1 Character")
        .max(64, "Maximum 64 Character"),
      description: yup
        .string()
        .required("Description is required")
        .max(512, "Maximum 512 Character"),
      start_date: yup.string().required("Start Date is required"),
      start_time: yup.string().required("Start Time is required"),
      end_date: yup.string().required("End Date is required"),
      end_time: yup.string().required("End Time is required"),
      coupon_code: yup
        .string()
        .required("Offer Code/Coupon Code is required")
        .min(1, "Minimum 1 Character")
        .max(15, "Maximum 15 Character"),
      maximum_usage_limit: yup
        .number()
        .positive()
        .min(1, "Maximum Usage Limit must be greater than or equal to 1")
        .required("Maximum Usage Limit is required")
        .moreThan(
          yup.ref("maxUsage"),
          "Maximum Usage Limit must be greater than Maximum Usage Limit for Entire Offer"
        ),
      useLimit: yup.number().required("User Usage Limit is required"),
      useFrequency: yup.string().required("Frequency is required"),
      maxUsage: yup
        .number()
        .positive()
        .required("Maximum Usage Limit for Entire offer is required")
        .min(
          1,
          "Maximum Usage Limit for Entire Offer must be greater than or equal to 1"
        )
        .lessThan(
          yup.ref("maximum_usage_limit"),
          "Maximum Usage Limit for Entire Offer must be less than Maximum Usage Limit"
        ),
      country: yup.string().required("Country is required"),
      // state: yup.string().required("State is required"),
      // city: yup.string().required("City is required"),
      terms_and_condition: yup
        .string()
        .required("Terms and Conditions are required")
        // .min(100, "Minimum 100 Character")
        .max(512, "Maximum 512 Character"),
      refund_and_cancellation: yup
        .string()
        .required("Refund and Cancellation is required")
        // .min(1, "Minimum 1 Character")
        .max(512, "Maximum 512 Character"),
      photos: yup.array().min(1, "Atleast one image should be uploaded"),
    }),

    onSubmit: (values) => {
      if (values.restaurants.length > 0) {
        handleTab(2);
      } else {
        Alert.error(`<h4>Select Active Merchants</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    },
  });

  const formik2 = useFormik({
    initialValues: {
      isPercentage: true,
      discount: "",
      minimum_order_applied: "",
      maximum_order_applied: "",
      maximum_discount_applied: "",
      service_type: [],
    },
    validationSchema: yup.object({
      discount: yup
        .number()
        .when("isPercentage", {
          is: true,
          then: yup
            .number()
            .lessThan(
              yup.ref("minimum_order_applied"),
              "Discount value must be less than minimum order value"
            ),
          otherwise: yup
            .number()
            .lessThan(
              yup.ref("minimum_order_applied"),
              "Discount value must be less than minimum order value"
            ),
        })
        .min(1, "value must be greater than or equal to 1"),
      minimum_order_applied: yup
        .number()
        .min(1, "Minimum Order Value must be greater than or equal to 1")
        .required("Minimum Order Value is required"),
      maximum_order_applied: yup
        .number()
        .min(1, "Maximum Order Value must be greater than or equal to 1")
        .moreThan(
          yup.ref("minimum_order_applied"),
          "Maximum Order Value must be greater than Minimum Order Value"
        ),
      maximum_discount_applied: yup.number().when("isPercentage", {
        is: true,
        then: yup.number().required("Maximum Discount Value is required"),
      }),
      // .lessThan(
      //   yup.ref("maximum_order_applied"),
      //   "Maximum discount value must be less than maximum order value"
      // ),
      service_type: yup.array().min(1, "Atleast one Service Type is required"),
    }),
    // validate,

    onSubmit: (values) => {
      let perpareData = {};
      var formData = {};
      const startDate = {
        start_date: moment(
          formik1.values.start_date + "T" + formik1.values.start_time
        ).toISOString(),
      };
      const end_Date = {
        end_date: moment(
          formik1.values.end_date + "T" + formik1.values.end_time
        ).toISOString(),
      };

      formData.name = formik1.values.name;
      formData.description = formik1.values.description;
      formData.mark_as_primary = formik1.values.mark_as_primary;
      formData.start_date = startDate.start_date;
      formData.end_date = end_Date.end_date;
      formData.coupon_code = formik1.values.coupon_code.toUpperCase();
      formData.maximum_usage_limit = formik1.values.maximum_usage_limit;
      formData.active = formik1.values.active;
      formData.useLimit = formik1.values.useLimit;
      formData.useFrequency = formik1.values.useFrequency;
      formData.maxUsage = formik1.values.maxUsage;
      formData.offerType = formik1.values.offerType;
      formData.country = formik1.values.country;
      formData.state = formik1.values.state;
      formData.city = formik1.values.city;
      formData.restaurants = formik1.values.restaurants;
      formData.photos = formik1.values.photos;
      formData.photo_thumbnails = formik1.values.photo_thumbnails;
      formData.offerVideo = state.video_url;
      formData.terms_and_condition = formik1.values.terms_and_condition;
      formData.refund_and_cancellation = formik1.values.refund_and_cancellation;
      formData.send_to_carousel = false;
      formData.isGlobal = formik1.values.isGlobal;
      formData.isOnline = formik1.values.isOnline;
      formData.pointOfEntry = formik1.values.pointOfEntry;
      formData.settlementType = formik1.values.settlementType;
      formData.isPercentage = values.isPercentage;
      formData.discount = values.discount;
      formData.minimum_order_applied = values.minimum_order_applied;
      formData.maximum_order_applied = values.maximum_order_applied;
      formData.maximum_discount_applied = values.maximum_discount_applied;
      formData.service_type = values.service_type;
      const token = props.auth.user.accessToken;
      // console.log(formData);
      if (formik2.values.isPercentage && formik2.values.discount === "") {
        formik2.setErrors({
          discount: "Discount Percentage is required",
        });
      } else if (
        !formik2.values.isPercentage &&
        formik2.values.discount === ""
      ) {
        formik2.setErrors({
          discount: "Discount Amount is required",
        });
      } else {
        dispatch(vendor_create_new_offer(formData, token, onSuccessAddOffer));
      }
    },
  });

  const onSuccessAddOffer = () => {
    setLoading(false);
    history.push("/superadminoffers");
  };

  const onErrorAddOffer = () => {
    setLoading(false);
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };

  const onClickSave2 = () => {
    setCount(count + 1);
    formik2.handleSubmit();
  };

  useEffect(() => {
    formik1.setFieldValue("name", "");
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
    dispatch(super_admin_get_country(token));
  }, []);

  useEffect(() => {
    setAllCountries(props?.getCountry);
  }, [props?.getCountry]);
  useEffect(() => {
    setAllStates(props?.getState);
  }, [props?.getState]);
  useEffect(() => {
    setAllCity(props?.getCity);
  }, [props?.getCity]);

  // for set focus
  useEffect(() => {
    if (formik1.errors && formik1.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik1.errors && formik1.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik1.errors && formik1.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik1.errors && formik1.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik1.errors && formik1.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik1.errors && formik1.errors.end_time) {
      let endTimeElement = document.getElementById("end_time");
      endTimeElement.focus();
    } else if (formik1.errors && formik1.errors.coupon_code) {
      let couponCodeElement = document.getElementById("coupon_code");
      couponCodeElement.focus();
    } else if (formik1.errors && formik1.errors.maximum_usage_limit) {
      let maximum_usage_limitElement = document.getElementById(
        "maximum_usage_limit"
      );
      maximum_usage_limitElement.focus();
    } else if (formik1.errors && formik1.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    } else if (formik1.errors && formik1.errors.refund_and_cancellation) {
      let refund_and_cancellationElement = document.getElementById(
        "refund_and_cancellation"
      );
      refund_and_cancellationElement.focus();
    }
  }, [count]);

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik1.setFieldValue("start_date", e.target.value);
    formik1.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };

  const handleStartEndDatekeydown = (e) => {
    e.preventDefault();
  };

  /****************************
   * @DESC Filler All Action
   ****************************/
  const onClickSaveFilter = () => {
    setRestaurantTypeFilter(state?.restaurantType);
    setRestaurantCityFilter(state?.restaurantCity);
    setShowFilter(false);
  };

  const onClickResetFilter = () => {
    setRestaurantTypeFilter("");
    setRestaurantCityFilter("");
    setShowFilter(false);
  };

  /**********************************************
   * @DESC Set User and Vendor Information
   **********************************************/
  const [getVendorUserInfo, setVendorUserInfo] = useState([]);
  const [finalVendorFilter, setFinalVendorFilter] = useState(0);
  useEffect(() => {
    setVendorUserInfo(props?.businessList);
  }, [props.businessList]);

  const vendorUserData = getVendorUserInfo && getVendorUserInfo;
  let filteredData = [];
  useEffect(() => {
    setFinalVendorFilter(filteredData && filteredData.length);
  }, [filteredData]);

  const RenderVendorUserTable = (actionBy) => {
    if (restaurantTypeFilter === "" && restaurantCityFilter === "") {
      filteredData = vendorUserData.filter((getall) => {
        return getall;
      });
    } else if (restaurantTypeFilter !== "") {
      filteredData = vendorUserData.filter(
        (getall) =>
          getall &&
          getall?.primary_restaurant_type?.title === restaurantTypeFilter
      );
    } else if (restaurantCityFilter !== "") {
      filteredData = vendorUserData.filter(
        (getall) => getall && getall?.city === restaurantCityFilter
      );
    }

    if (searchData) {
      let search = new RegExp(searchData, "i");
      filteredData = vendorUserData.filter((getall) => {
        if (search.test(getall?._id)) {
          return getall;
        } else if (search.test(getall.restaurant_name)) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <ListMerchantTableBody
            userType={data}
            //  actionPerform={actionBy ? "VENDOR" : "USER"}
            onClickCheckBoxAction={() => onClickCheckBox(data._id)}
            selectedCheck={formik1.values.restaurants.includes(data._id)}
          />
        </React.Fragment>
      ));
    } else {
      return (
        <React.Fragment>
          <div className="text-center">
            <h3 className="f16-500 opacity5 py-2">NO RECORDS FOUND</h3>
          </div>
        </React.Fragment>
      );
    }
  };

  /*******************************
   * @DESC Click Check Box
   ******************************/
  const onClickCheckBox = (id) => {
    const selectedCheckboxes = formik1.values.restaurants;
    const findIdx = selectedCheckboxes.indexOf(id);
    if (findIdx > -1) {
      selectedCheckboxes.splice(findIdx, 1);
    } else {
      selectedCheckboxes.push(id);
    }
    formik1.setFieldValue("restaurants", selectedCheckboxes);
  };

  const onHeadCheckBox = (allVendorUserData, userData) => {
    const data = allVendorUserData;
    let restaurantsID = userData;
    var keyArray = [];
    if (restaurantsID.length > 0) {
      var ele = document.getElementsByName("restaurants");
      formik1.setFieldValue("headCheck", false);

      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == "checkbox") ele[i].checked = false;
      }
      formik1.setFieldValue("restaurants", []);
    } else {
      data.map(function (item) {
        keyArray.push(item["_id"]);
      });
      formik1.setFieldValue("restaurants", []);
      restaurantsID.push(...keyArray);
      formik1.setFieldValue("restaurants", restaurantsID);
      formik1.setFieldValue("headCheck", true);
      var ele = document.getElementsByName("restaurants");
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].type == "checkbox") ele[i].checked = true;
      }
    }
  };
  console.log(filteredData, "data");
  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <div className="d-flex align-items-center mb-4">
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 1 ? "active" : ""
          }`}
        >
          General Information
        </Button>
        <Button
          variant="link"
          className={`px-0 mr-4 text-grayLink f12-500 ${
            selectedTab === 2 ? "active" : ""
          }`}
        >
          Offer Settings
        </Button>
      </div>
      {selectedTab === 1 && (
        <Form>
          <Row className="pt-4">
            <Col lg={7} className="mb-3">
              <Form.Group>
                <TextField
                  // ref={nameee}
                  id="name"
                  label="Offer Name*"
                  type="text"
                  variant="outlined"
                  className={`w-100 ${
                    formik1.errors.name && formik1.touched.name ? "enError" : ""
                  }`}
                  name="name"
                  onChange={formik1.handleChange}
                  value={formik1.values.name}
                  onBlur={formik1.handleBlur}
                  isInvalid={formik1.errors.name && formik1.touched.name}
                />
                {formik1.errors.name && formik1.touched.name ? (
                  <div className="pho_14_regular text-danger">
                    {formik1.errors.name}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={8}>
              <Form.Group id="textbox-offer-input">
                <TextField
                  // ref={description}
                  id="description"
                  label="Description*"
                  type="text"
                  multiline
                  rows="5"
                  variant="outlined"
                  className={`w-100 ${
                    formik1.errors.description && formik1.touched.description
                      ? "enError"
                      : ""
                  }`}
                  name="description"
                  onChange={formik1.handleChange}
                  value={formik1.values.description}
                  onBlur={formik1.handleBlur}
                  //onInvalid={formik1.errors.email && formik1.touched.email}
                  isInvalid={
                    formik1.errors.description && formik1.touched.description
                  }
                />
                {formik1.errors.description && formik1.touched.description ? (
                  <div className="pho_14_regular text-danger">
                    {formik1.errors.description}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={9}>
              <Row>
                <Col lg={6}>
                  <div className="f11-400 opacity5 pb-2">
                    Fill out the details, max 512 characters
                  </div>
                </Col>
                <Col lg={6}>
                  {/* <div className="d-flex align-items-start">
                    <Switch
                      checked={formik1.values?.mark_as_primary}
                      onChange={() => onClickChangePrimary()}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                    <div className="pl-2">
                      <div className="f11-500 mb-2">
                        Make this Offer Primary
                      </div>
                      <div className="f11-400 opacity5">
                        (Note you can make only one Offer primary, by making
                        this offer primary it will remove primary from other
                        active offers)
                      </div>
                    </div>
                  </div> */}
                </Col>
              </Row>
            </Col>
            <Col lg={10} className="my-3">
              <hr />
            </Col>
            <Col lg={9} className="mb-3">
              <div className="f16-500 mb-4">Offer Details*</div>
              <Row className="align-items-center">
                <Col xs={12} sm={6} md={6} xl={6} className="py-3">
                  <Row>
                    <Col xs={5} sm={5} md={5} xl={5} className="pr-md-0">
                      <TextField
                        id="start_date"
                        label="Start Date"
                        variant="outlined"
                        InputProps={{
                          inputProps: { min: minDate },
                        }}
                        type="date"
                        defaultValue={minDate}
                        className={`w-100 ${
                          formik1.errors.start_date &&
                          formik1.touched.start_date
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="start_date"
                        onChange={(e) => handleStartDateChange(e)}
                        //onChange={formik1.handleChange}
                        value={formik1.values.start_date}
                        onBlur={formik1.handleBlur}
                        //onInvalid={formik1.errors.email && formik1.touched.email}
                        isInvalid={
                          formik1.errors.start_date &&
                          formik1.touched.start_date
                        }
                        onKeyDown={(e) => handleStartEndDatekeydown(e)}
                        onKeyUp={(e) => handleStartEndDatekeydown(e)}
                      />
                      {formik1.errors.start_date &&
                      formik1.touched.start_date ? (
                        <div className="pho_14_regular text-danger">
                          {formik1.errors.start_date}
                        </div>
                      ) : null}
                    </Col>
                    <Col
                      xs={2}
                      sm={2}
                      md={2}
                      xl={2}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <h5 className="f14-400">at</h5>
                    </Col>
                    <Col xs={5} sm={5} md={5} xl={5} className="pl-md-0">
                      <TextField
                        id="start_time"
                        label="Start Time"
                        variant="outlined"
                        type="time"
                        className={`w-100 ${
                          formik1.errors.start_time &&
                          formik1.touched.start_time
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="start_time"
                        onChange={formik1.handleChange}
                        value={formik1.values.start_time}
                        onBlur={formik1.handleBlur}
                        isInvalid={
                          formik1.errors.start_time &&
                          formik1.touched.start_time
                        }
                      />
                      {formik1.errors.start_time &&
                      formik1.touched.start_time ? (
                        <div className="pho_14_regular text-danger">
                          {formik1.errors.start_time}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={6} xl={6} className="py-3 border-left">
                  <Row>
                    <Col xs={5} sm={5} md={5} xl={5} className="pr-md-0">
                      <TextField
                        id="end_date"
                        label="End Date"
                        variant="outlined"
                        InputProps={{
                          inputProps: { min: minEndDate },
                        }}
                        type="date"
                        className={`w-100 ${
                          formik1.errors.end_date && formik1.touched.end_date
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="end_date"
                        onChange={formik1.handleChange}
                        value={formik1.values.end_date}
                        onBlur={formik1.handleBlur}
                        isInvalid={
                          formik1.errors.end_date && formik1.touched.end_date
                        }
                        onKeyDown={(e) => handleStartEndDatekeydown(e)}
                        onKeyUp={(e) => handleStartEndDatekeydown(e)}
                      />
                      {formik1.errors.end_date && formik1.touched.end_date ? (
                        <div className="pho_14_regular text-danger">
                          {formik1.errors.end_date}
                        </div>
                      ) : null}
                    </Col>
                    <Col
                      xs={2}
                      sm={2}
                      md={2}
                      xl={2}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <h5 className="f14-400">at</h5>
                    </Col>
                    <Col xs={5} sm={5} md={5} xl={5} className="pl-md-0">
                      <TextField
                        id="end_time"
                        label="End Time"
                        variant="outlined"
                        type="time"
                        className={`w-100 ${
                          formik1.errors.end_time && formik1.touched.end_time
                            ? "enError"
                            : ""
                        }`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="end_time"
                        onChange={formik1.handleChange}
                        value={formik1.values.end_time}
                        onBlur={formik1.handleBlur}
                        isInvalid={
                          formik1.errors.end_time && formik1.touched.end_time
                        }
                      />
                      {formik1.errors.end_time && formik1.touched.end_time ? (
                        <div className="pho_14_regular text-danger">
                          {formik1.errors.end_time}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="align-items-center mt-4">
                <Col xs={12} sm={12} md={4} xl={4}>
                  <Form.Group className="mb-0">
                    <NewInputText
                      extraClass={`${
                        formik1.errors.coupon_code &&
                        formik1.touched.coupon_code
                          ? "mb-1"
                          : "mb-3"
                      }`}
                      name="coupon_code"
                      maxLength={15}
                      onInput={maxLengthCheck}
                      inputType="text"
                      onKeyDown={InputNumberFuncWithE}
                      onFocusOut={formik1.handleBlur}
                      onChange={formik1.handleChange}
                      value={formik1.values.coupon_code.toUpperCase()}
                      labelText="Offer Code/Coupon Code"
                      controlClass="coupon_code"
                    />
                    {formik1.errors.coupon_code &&
                    formik1.touched.coupon_code ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.coupon_code}
                      </div>
                    ) : null}
                  </Form.Group>
                  {formik1.errors.coupon_code && formik1.touched.coupon_code ? (
                    ""
                  ) : (
                    <div className="f10-400 opacity5">
                      Coupon Code max 15 characters
                    </div>
                  )}
                </Col>
                <Col xs={7} sm={7} md={5} xl={5}>
                  <Form.Group>
                    <NewInputText
                      extraClass="mb-1"
                      name="maximum_usage_limit"
                      maxLength={5}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onInput={maxLengthCheck}
                      inputType="number"
                      onKeyDown={InputNumberFunc}
                      onFocusOut={formik1.handleBlur}
                      onChange={formik1.handleChange}
                      value={formik1.values.maximum_usage_limit}
                      labelText="Maximum Usage Limit"
                      controlClass="maximum_usage_limit"
                      onpaste={(e) => e.preventDefault()}
                    />
                    {formik1.errors.maximum_usage_limit &&
                    formik1.touched.maximum_usage_limit ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.maximum_usage_limit}
                      </div>
                    ) : null}
                  </Form.Group>
                  {formik1.errors.maximum_usage_limit &&
                  formik1.touched.maximum_usage_limit ? (
                    ""
                  ) : (
                    <div className="f10-400 opacity5">
                      Maximum usage limit is total limit set for the offer
                    </div>
                  )}
                </Col>
                <Col xs={5} sm={5} md={3} xl={3}>
                  <div className="form-group d-flex align-items-center justify-content-end">
                    <div className="f16-500 mr-2">Status</div>
                    <div className="f12-400 mr-2 w-25">
                      {formik1.values?.active ? "Active" : "Inactive"}
                    </div>
                    <Switch
                      checked={formik1.values?.active}
                      onChange={() =>
                        formik1.setFieldValue("active", !formik1.values?.active)
                      }
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                </Col>
              </Row>
              <div className="f16-500 mt-4">Offer Usage Limit*</div>
              <p className="f10-400 opacity5 mb-4">
                Set the user Offer Usage Limit frequency by day, week, month or
                year
              </p>
              <Row className="align-items-center">
                <Col xs={7} sm={7} md={4} xl={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="demo-simple-select-label">
                      User Usage Limit
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="useLimit"
                      name="useLimit"
                      value={formik1.values?.useLimit}
                      onChange={formik1.handleChange}
                      label="User Usage Limit"
                    >
                      <MenuItem value="" disabled selected>
                        Select User Usage Limit
                      </MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                    </Select>
                    {formik1.errors.useLimit && formik1.touched.useLimit ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.useLimit}
                      </div>
                    ) : null}
                  </FormControl>
                </Col>
                <Col xs={5} sm={5} md={3} xl={3}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="demo-simple-select-label">
                      Frequency
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="useFrequency"
                      name="useFrequency"
                      value={formik1.values?.useFrequency}
                      onChange={formik1.handleChange}
                      label="Frequency"
                    >
                      <MenuItem value="" disabled selected>
                        Select Frequency
                      </MenuItem>
                      <MenuItem value={"DAILY"}>Day</MenuItem>
                      <MenuItem value={"WEEKLY"}>Week</MenuItem>
                      <MenuItem value={"MONTHLY"}>Month</MenuItem>
                      <MenuItem value={"YEARLY"}>Year</MenuItem>
                    </Select>
                    {formik1.errors.useFrequency &&
                    formik1.touched.useFrequency ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.useFrequency}
                      </div>
                    ) : null}
                  </FormControl>
                </Col>
                <Col xs={12} sm={12} md={5} xl={5}>
                  <Form.Group className="mb-0">
                    <NewInputText
                      extraClass="mb-0"
                      name="maxUsage"
                      maxLength={5}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onInput={maxLengthCheck}
                      inputType="number"
                      onKeyDown={InputNumberFunc}
                      onFocusOut={formik1.handleBlur}
                      onChange={formik1.handleChange}
                      value={formik1.values.maxUsage}
                      labelText="Maximum Usage Limit for Entire Offer"
                      controlClass="maxUsage"
                      onpaste={(e) => e.preventDefault()}
                    />
                    {formik1.errors.maxUsage && formik1.touched.maxUsage ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.maxUsage}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col lg={10}>
              <hr />
            </Col>
            <Col lg={9}>
              <h5 className="f16-500 mb-4 mt-2">Offer Settings</h5>
              <Row className="checkbox-bank-account justify-content-start mb-4">
                {amealioOffers.map((type, index) => {
                  return (
                    <Col md={6} key={index}>
                      <label className="enRadioWithText small">
                        <div
                          className={`f14-500 ${!type.show ? "opacity5" : ""} `}
                        >
                          {type.title}
                          <p className="f10-400 opacity5 w-75 mt-2">
                            {type.paragraph}
                          </p>
                        </div>
                        <input
                          id="offerType"
                          type="radio"
                          name="offerType"
                          value={
                            formik1.values.offerType === type.value
                              ? true
                              : false
                          }
                          onChange={() => offerTypeAction(type.value)}
                          checked={
                            formik1.values.offerType === type.value
                              ? true
                              : false
                          }
                          disabled={!type.show ? true : false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </Col>
                  );
                })}
                {formik1.errors.offerType && formik1.touched.offerType ? (
                  <div className="pho_14_regular text-danger">
                    {formik1.errors.offerType}
                  </div>
                ) : null}
              </Row>
              <Row>
                <Col xs={12} sm={6} md={4} xl={4}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Country">
                        Country*
                      </InputLabel>
                      <Select
                        value={formik1?.values?.country}
                        onChange={onChangeCountry}
                        label="country*"
                        inputProps={{
                          name: "country",
                          id: "outlined-country",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {countries &&
                          countries.map((country, index) => (
                            <MenuItem key={index} value={country}>
                              {country}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {formik1.errors.country && formik1.touched.country ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.country}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={4} xl={4}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-state">State</InputLabel>
                      <Select
                        value={formik1?.values?.state}
                        onChange={onChangeState}
                        label="state"
                        inputProps={{
                          name: "state",
                          id: "outlined-state",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {states &&
                          states.map((state, index) => (
                            <MenuItem key={index} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {formik1.errors.state && formik1.touched.state ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.state}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={4} xl={4}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-state">City</InputLabel>
                      <Select
                        value={formik1?.values?.city}
                        onChange={onChangeCity}
                        label="city"
                        inputProps={{
                          name: "city",
                          id: "outlined-state",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {city &&
                          city.map((city, index) => (
                            <MenuItem key={index} value={city}>
                              {city}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {formik1.errors.city && formik1.touched.city ? (
                      <div className="pho_14_regular text-danger">
                        {formik1.errors.city}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col lg={10} className="mt-4">
              <h5 className="f16-500">List of Active Merchants</h5>
              <hr className="mb-2" />
              <Row>
                <Col md={6} className="d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <Image
                      alt="Search"
                      title="Search"
                      width="60px"
                      src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
                      onClick={(e) => onClickDisplaySearch(e)}
                    />
                    <Image
                      src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                      width="60px"
                      alt="Filter"
                      title="Filter"
                      onClick={(e) => onClickDisplayFilter(e)}
                    />
                  </div>
                </Col>
                <Col
                  md={6}
                  className="col-md-6 d-flex align-items-center justify-content-end"
                >
                  <h5 className="f12-400">
                    Total Number of Merchants :{" "}
                    {props.auth.secondary_loader ? (
                      <div className="ml-2">
                        <Loader
                          type="ThreeDots"
                          color="#00BFFF"
                          height={25}
                          width={25}
                        />
                      </div>
                    ) : (
                      finalVendorFilter && finalVendorFilter
                    )}
                  </h5>
                </Col>
                <div className="col-12">
                  {showSearch && (
                    <div className="my-3">
                      <ZoomDiv>
                        <div className="w-25">
                          <Form.Control
                            type="text"
                            placeholder="Search"
                            value={searchData}
                            onChange={(e) => setSearchData(e.target.value)}
                            className="amSearch"
                          />
                        </div>
                      </ZoomDiv>
                    </div>
                  )}
                  {showFilter && (
                    <div
                      className="container-fluid p-4"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                City
                              </InputLabel>
                              <Select
                                value={state?.restaurantCity}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    restaurantCity: e.target.value,
                                  })
                                }
                                label="City"
                                inputProps={{
                                  name: "restaurantCity",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""} disabled>
                                  Select option
                                </option>
                                {props?.getCity &&
                                  props?.getCity?.map((data, index) => (
                                    <option value={data} key={index}>
                                      {data}
                                    </option>
                                  ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Restaurant Type
                              </InputLabel>
                              <Select
                                value={state?.restaurantType}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    restaurantType: e.target.value,
                                  })
                                }
                                label="Restaurant Type"
                                inputProps={{
                                  name: "restaurantType",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""} disabled>
                                  Select option
                                </option>
                                {props?.restaurantType.map((data, index) => (
                                  <option value={data?.title} key={index}>
                                    {data?.title}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div class="mt-5 d-flex">
                        <button
                          type="button"
                          onClick={() => onClickResetFilter()}
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                          title="Reset Filter"
                        >
                          Reset
                        </button>
                        <button
                          type="button"
                          onClick={() => onClickSaveFilter()}
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          title="Search Filter"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <Col sm={12}>
                  {props.auth.secondary_loader ? (
                    <Loader
                      type="ThreeDots"
                      color="#00BFFF"
                      height={25}
                      width={25}
                    />
                  ) : vendorUserData && vendorUserData.length !== 0 ? (
                    <div
                      className="col-12 p-0 user-table-reusable-superadmin my-2"
                      style={{
                        // maxHeight: "400px",
                        // overflow: "auto",
                        border: "1px solid #00000029",
                        borderRadius: "10px",
                      }}
                    >
                      <Table
                        style={{ borderSpacing: 0, borderCollapse: "collapse" }}
                      >
                        <thead>
                          <ListMarchantTableHead
                            restaurantsOnChange={() =>
                              onHeadCheckBox(
                                vendorUserData && vendorUserData,
                                formik1.values.restaurants
                              )
                            }
                            selectedCheck={formik1.values.headCheck}
                          />
                        </thead>
                        <div
                          id="style-4"
                          style={{
                            maxHeight: "400px",
                            overflow: "auto",
                          }}
                        >
                          {RenderVendorUserTable()}
                        </div>
                      </Table>
                    </div>
                  ) : (
                    <React.Fragment>
                      <div className="text-center">
                        <h3 className="f16-500 opacity5">NO RECORDS FOUND</h3>
                      </div>
                    </React.Fragment>
                  )}
                </Col>
              </Row>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col md={10}>
              <div className="event-offer-image">
                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Upload Images*"
                    // smallTitle="(You can upload maximum 5 pic per offer 700 x 420 pixels)"
                    onChange={bankUploadMultipleFiles}
                    //stateValue={bank_informaion}
                    stateValue={formik1.values.photos}
                    newUploaded={
                      restaurant_pictures_new ? restaurant_pictures_new : []
                    }
                    combined={combined}
                    cancelFiles={cancelFiles}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    removeImage={bankDocMultipleRemove}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                    // loader={state.bankImageLoader}
                    thumbnail={thumbnail}
                  />
                </SimpleReactLightbox>
              </div>
              {formik1.errors.photos && formik1.touched.photos ? (
                <div className="mb-3 pho_14_regular text-danger">
                  {formik1.errors.photos}
                </div>
              ) : (
                <div className="f10-500 opacity5 mb-3 d-flex">
                  (You can upload maximum 5 pics per offer 700 x 420 pixels)
                </div>
              )}
            </Col>
            <Col md={10}>
              <hr />
            </Col>
            <Col md={10}>
              <div className="event-offer-image">
                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Upload Video"
                    onChange={uploadMultipleVideoFiles}
                    stateValue={state.video_url === "" ? [] : [state.video_url]}
                    removeImage={multipleVideoResetFile}
                    accept="video/*"
                    singleUpload={true}
                    videoUpload={true}
                    disabled={disable}
                  />
                  <div className="f10-500 opacity5 mb-4 d-flex">
                    (You can upload only 1 video per offer less than 5 mb)
                  </div>
                </SimpleReactLightbox>
                {!state.progress && state.progress === 0 ? null : (
                  <AlertDialogProgress
                    progress={state.progress}
                    title="Video Uploading..."
                  />
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={8}>
              <Form.Group id="textbox-offer-input">
                <TextField
                  id="terms_and_condition"
                  label="Terms and Conditions*"
                  type="text"
                  multiline
                  rows="5"
                  variant="outlined"
                  className={`w-100 ${
                    formik1.errors.terms_and_condition &&
                    formik1.touched.terms_and_condition
                      ? "enError"
                      : ""
                  }`}
                  name="terms_and_condition"
                  onChange={formik1.handleChange}
                  value={formik1.values.terms_and_condition}
                  onBlur={formik1.handleBlur}
                  isInvalid={
                    formik1.errors.terms_and_condition &&
                    formik1.touched.terms_and_condition
                  }
                />
                {formik1.errors.terms_and_condition &&
                formik1.touched.terms_and_condition ? (
                  <div className="pho_14_regular text-danger">
                    {formik1.errors.terms_and_condition}
                  </div>
                ) : null}
                <div className="py-2 f10-400 opacity5 pb-5">
                  (Fill out the terms and conditions for the offers used online)
                </div>
              </Form.Group>
              <Form.Group id="textbox-offer-input">
                <TextField
                  id="refund_and_cancellation"
                  label="Refund  and Cancellation*"
                  type="text"
                  multiline
                  rows="5"
                  variant="outlined"
                  name="refund_and_cancellation"
                  className={`w-100 ${
                    formik1.errors.refund_and_cancellation &&
                    formik1.touched.refund_and_cancellation
                      ? "enError"
                      : ""
                  }`}
                  onChange={formik1.handleChange}
                  value={formik1.values.refund_and_cancellation}
                  onBlur={formik1.handleBlur}
                  isInvalid={
                    formik1.errors.refund_and_cancellation &&
                    formik1.touched.refund_and_cancellation
                  }
                />
                {formik1.errors.refund_and_cancellation &&
                formik1.touched.refund_and_cancellation ? (
                  <div className="pho_14_regular text-danger">
                    {formik1.errors.refund_and_cancellation}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={() => history.push("/superadminoffers")}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5 btn150px"
              onClick={() => onClickSave()}
            >
              Next
            </Button>
          </div>
        </Form>
      )}
      {selectedTab === 2 && (
        <Form>
          <div className="f16-500 pt-3 pb-5">Coupon Discount Type</div>
          <Row className="checkbox-bank-account justify-content-start mb-4">
            {percentArr.map((type, index) => {
              return (
                <Col md={3} key={index}>
                  <label className="enRadioWithText small">
                    <div className={`f14-500`}>{type.title}</div>
                    <input
                      id="isPercentage"
                      type="radio"
                      name="isPercentage"
                      value={
                        formik2?.values?.isPercentage === type?.value
                          ? true
                          : false
                      }
                      onChange={() => isPercentageAction(type?.value)}
                      checked={
                        formik2?.values?.isPercentage === type?.value
                          ? true
                          : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </Col>
              );
            })}
          </Row>
          <Row className="align-items-center pb-4">
            <Col xs={8} md={2}>
              <div className="d-flex align-items-center">
                <NewInputText
                  extraClass="mb-1"
                  name="discount"
                  maxLength={formik2.values?.isPercentage ? 2 : 5}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onInput={maxLengthCheck}
                  inputType="number"
                  onKeyDown={InputNumberFunc}
                  onFocusOut={formik2.handleBlur}
                  onChange={formik2.handleChange}
                  value={formik2.values.discount}
                  labelText={
                    formik2.values?.isPercentage
                      ? "Discount Percentage*"
                      : "Discount Amount*"
                  }
                  controlClass="discount"
                  onpaste={(e) => e.preventDefault()}
                />
                <div className="f16-500 ml-2">
                  {formik2.values?.isPercentage ? "%" : "Rs."}
                </div>
              </div>
              {formik2.errors.discount && formik2.touched.discount ? (
                <div className="pho_14_regular text-danger">
                  {formik2.errors.discount}
                  {/* {formik2.errors.discount === "Discount Amount is required" ||
                  formik2.values?.isPercentage
                    ? "Discount Amount is required"
                    : "Fixed Amount is required"} */}
                </div>
              ) : null}
            </Col>
          </Row>
          <div className="f18-700 py-4">Minimum Order Value*</div>
          <div className="row align-items-center pb-4">
            <Col xs={8} md={2}>
              <NewInputText
                extraClass="mb-1"
                name="minimum_order_applied"
                maxLength={4}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onInput={maxLengthCheck}
                inputType="number"
                onKeyDown={InputNumberFunc}
                onFocusOut={formik2.handleBlur}
                onChange={formik2.handleChange}
                value={formik2.values.minimum_order_applied}
                labelText="Value"
                controlClass="minimum_order_applied"
                onpaste={(e) => e.preventDefault()}
              />
            </Col>
            <div className="col-12">
              {formik2.errors.minimum_order_applied &&
              formik2.touched.minimum_order_applied ? (
                <div className="pho_14_regular text-danger">
                  {formik2.errors.minimum_order_applied}
                </div>
              ) : (
                <div className="f11-400 opacity5">
                  Enter minimum order value above which the offer can be applied
                </div>
              )}
            </div>
          </div>

          <div className="f18-700 py-4">Maximum Order Value</div>
          <div className="row align-items-center pb-4">
            <Col xs={8} md={2}>
              <NewInputText
                extraClass="mb-1"
                name="maximum_order_applied"
                maxLength={4}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onInput={maxLengthCheck}
                inputType="number"
                onKeyDown={InputNumberFunc}
                onFocusOut={formik2.handleBlur}
                onChange={formik2.handleChange}
                value={formik2.values.maximum_order_applied}
                labelText="Value"
                controlClass="maximum_order_applied"
                onpaste={(e) => e.preventDefault()}
              />
            </Col>
            <div className="col-12">
              {formik2.errors.maximum_order_applied &&
              formik2.touched.maximum_order_applied ? (
                <div className="pho_14_regular text-danger">
                  {formik2.errors.maximum_order_applied}
                </div>
              ) : (
                <div className="f11-400 opacity5">
                  Enter maximum order value above which the offer cannot be
                  applied
                </div>
              )}
            </div>
          </div>

          {!formik2?.values?.isPercentage ? (
            <></>
          ) : (
            <>
              <div className="f18-700 py-4">Maximum Discount Value*</div>
              <div className="row align-items-center pb-4">
                <Col xs={8} md={2}>
                  <NewInputText
                    extraClass="mb-1"
                    name="maximum_discount_applied"
                    maxLength={4}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onInput={maxLengthCheck}
                    inputType="number"
                    onKeyDown={InputNumberFunc}
                    onFocusOut={formik2.handleBlur}
                    onChange={formik2.handleChange}
                    value={formik2.values.maximum_discount_applied}
                    labelText="Value"
                    controlClass="maximum_discount_applied"
                    onpaste={(e) => e.preventDefault()}
                  />
                </Col>
                <div className="col-12">
                  {formik2.errors.maximum_discount_applied &&
                  formik2.touched.maximum_discount_applied ? (
                    <div className="pho_14_regular text-danger">
                      {formik2.errors.maximum_discount_applied}
                    </div>
                  ) : (
                    <div className="f11-400 opacity5">
                      Enter maximum discount value upto which discount can be
                      availed
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          <Col lg={10}>
            <hr />
          </Col>
          <Row>
            <Col lg={10}>
              <div className="f16-500 py-4">Applicable To Services*</div>
              <div className="w-100 row mb-4">
                {days.map((day, index) => {
                  return (
                    <Col lg={2} key={index}>
                      <ReusableOnboardingMapButton
                        classsection={
                          formik2?.values?.service_type.some(
                            (icons) => icons === day.name
                          )
                            ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }
                        title={day.name}
                        onClick={() => onChangeDaysEatOut(day)}
                      />
                    </Col>
                  );
                })}
              </div>
              {formik2.errors.service_type && formik2.touched.service_type ? (
                <div className="pho_14_regular text-danger">
                  {formik2.errors.service_type}
                </div>
              ) : null}
            </Col>
            <div className="py-4 d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5 btn150px"
                onClick={() => handleTab(1)}
              >
                Back
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5 btn150px"
                type="button"
                onClick={() => onClickSave2()}
              >
                Save
              </Button>
            </div>
          </Row>
        </Form>
      )}
    </React.Fragment>
  );
};

AdminAddOnlineOffers.propTypes = {
  auth: PropTypes.object.isRequired,
  vendor_create_new_offer: PropTypes.func.isRequired,
  super_admin_get_country: PropTypes.func.isRequired,
  super_admin_get_state: PropTypes.func.isRequired,
  super_admin_get_city: PropTypes.func.isRequired,
  super_admin_get_restaurant_list: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state.onboarding.restaurantDetails,
  getCountry: state.superAdminOfflineOnlineOffers?.country,
  getState: state.superAdminOfflineOnlineOffers?.state,
  getCity: state.superAdminOfflineOnlineOffers?.city,
  businessList: state.superAdminOfflineOnlineOffers?.businessList,
  restaurantType: state.category?.restaurant_type,
});

export default connect(mapStateToProps, {
  // addOfferAdminRestaurant,
  vendor_create_new_offer,
  super_admin_get_country,
  super_admin_get_state,
  super_admin_get_city,
  super_admin_get_restaurant_list,
})(AdminAddOnlineOffers);
